<template>
  <div id="app">
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view />
    </keep-alive>

    <router-view v-else />
  </div>
</template>


<script>
import { getUrlParams } from '@/assets/js/tool.js'
export default {
  created() {
    let sourceId = getUrlParams(location.href, 'sourceId')
    if (sourceId) {
      this.$router.push({ path: '/course', query: { sourceId } })
    }
  },
}
</script>
<style>
@import 'assets/scss/index.scss';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
